<div class="divider-tool-wrapper" [ngStyle]="getContainerStyles()">
  <div class="divider-tool-border" [ngStyle]="getStyles()"></div>
</div>
